import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _FavoriteGetter = Getter.of();
export const _FavoriteResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _FavoriteResponse2Favorite = _Response2ResponseData();
export const _FavoriteResponse2Meta = Fold.compose(_FavoriteResponseGetter, Res._Response(), Lens.prop("meta"));
export const _Favorite2Data = Fold.compose(_FavoriteGetter, Res._Response());
export const _Favorite2Attributes = Fold.compose(_Favorite2Data, Lens.prop("attributes"));
export const _Favorite2FavoritesVideos = Fold.compose(_FavoriteGetter, Res._RelAssoc("favorites", "videos"), Res._ForEach());
export const _Favorite2FavoritesChannels = Fold.compose(_FavoriteGetter, Res._RelAssoc("favorites", "channels"), Res._ForEach());
export const _Favorite2FavoritesShows = Fold.compose(_FavoriteGetter, Res._RelAssoc("favorites", "shows"), Res._ForEach());
export const _Favorite2FavoritesLinks = Fold.compose(_FavoriteGetter, Res._RelAssoc("favorites", "links"), Res._ForEach());
export const _Favorite2FavoritesGenres = Fold.compose(_FavoriteGetter, Res._RelAssoc("favorites", "genres"), Res._ForEach());
export const _Favorite2FavoritesTaxonomyNodes = Fold.compose(_FavoriteGetter, Res._RelAssoc("favorites", "taxonomyNodes"), Res._ForEach());

